import { FC } from 'react'
import {
  CalendarIcon,
  CardStackPlusIcon,
  GearIcon,
  GlobeIcon,
  IdCardIcon,
  LockClosedIcon,
  LockOpen1Icon,
  PaperPlaneIcon,
  Pencil2Icon,
  PersonIcon,
  PlusIcon,
  ReloadIcon,
  TrashIcon
} from '@radix-ui/react-icons'
import Ghost from 'Assets/ghost.svg'

export enum PeopleAction {
  ManagePermissions = 'Manage Permissions',
  ManageInformation = 'Manage Information',
  ManageBenefits = 'Manage Benefits',
  TerminateBenfits = 'Terminate Benefits',
  UnlockAccount = 'Unlock Account',
  ReEnableBenefits = 'Re-enable User',
  ResendInvite = 'Resend Invite',
  CancelInvite = 'Cancel Invite',
  ManageUserAllowances = 'Manage Allowances',
  ManageUserRecurringAllowances = 'Manage Recurring Allowances',
  ImpersonateUser = 'Impersonate User',
  StripeAccountDelete = 'Delete Stripe Account',
  UpdateCountry = 'Update Country',
  TerminateBenfitsAndAdmin = 'Terminate Benefits/Admin',
  ResetPurchaseAccount = 'Reset Renew Date (Truelayer)',
  ViewEnrollmentHistory = 'View Enrollment History',
  RefreshTransactions = 'Refresh Transactions',
  AddPurchase = 'Add Purchase'
}

export enum ActionType {
  UserModifications = 'User Modifications',
  ProgramModifications = 'Program Modifications'
}

export const getActionIcon = (action: PeopleAction | ActionType) => {
  switch (action) {
    case ActionType.UserModifications:
    case ActionType.ProgramModifications:
      return <GearIcon />
    case PeopleAction.ManagePermissions:
      return <LockClosedIcon />
    case PeopleAction.ManageInformation:
      return <IdCardIcon />
    case PeopleAction.ManageBenefits:
      return <Pencil2Icon />
    case PeopleAction.StripeAccountDelete:
    case PeopleAction.TerminateBenfits:
    case PeopleAction.TerminateBenfitsAndAdmin:
    case PeopleAction.CancelInvite:
      return <TrashIcon />
    case PeopleAction.ReEnableBenefits:
    case PeopleAction.ViewEnrollmentHistory:
      return <PersonIcon />
    case PeopleAction.ResendInvite:
      return <PaperPlaneIcon />
    case PeopleAction.ManageUserAllowances:
      return <CardStackPlusIcon />
    case PeopleAction.ManageUserRecurringAllowances:
      return <CalendarIcon />
    case PeopleAction.UpdateCountry:
      return <GlobeIcon />
    case PeopleAction.ResetPurchaseAccount:
      return <ReloadIcon />
    case PeopleAction.UnlockAccount:
      return <LockOpen1Icon />
    case PeopleAction.RefreshTransactions:
      return <ReloadIcon />
    case PeopleAction.ImpersonateUser:
      return <img src={Ghost} alt={'spooky'} />
    case PeopleAction.AddPurchase:
      return <PlusIcon />
    default:
      return null
  }
}

type ActionLabelProps = {
  action: PeopleAction | ActionType
}
export const ActionLabel: FC<ActionLabelProps> = ({ action }) => {
  return (
    <>
      {getActionIcon(action)}
      {action}
    </>
  )
}
